import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=2dacbc2c&scoped=true"
import script from "./appointmentList.vue?vue&type=script&lang=js"
export * from "./appointmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacbc2c",
  null
  
)

export default component.exports